import type { LabelTemplate } from '@toolproof-core/visualization/_contract/declaration';

import { PRESENTATION_DEFAULTS } from '@/workflow/_data/config/fragments/_@shared/presentationDefaults';

export const ABOVE_ITEM_LABEL: LabelTemplate = {
    color: PRESENTATION_DEFAULTS.colors.labels.aboveItemText,
    fontSize: 0.6,
    padding: 0.12,
    orientation: { orientationKind: 'billboard' },
    backgroundColor: PRESENTATION_DEFAULTS.colors.labels.aboveItemBackground,
    backgroundOpacity: 0.0,
};

export const FLAG_ABOVE_ITEM_LABEL: LabelTemplate = {
    ...ABOVE_ITEM_LABEL,
    backgroundOpacity: 0.85,
    flag: {
        postOffset: [0, -1.5, 0],
        minTextPixels: 1,
    },
};